module.exports = __webpack_public_path__ + "img/forum.7842a931.svg";